/*Import Estilo*/
import './index.scss';
import '../../css/global.css';
import '../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import CookieAceite from '../../components/CookieAceite';

/*Import Contexto*/
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';

/*Import Utils*/
import { formatarPrecoUnitario } from '../../utils/precoUnitario';

/*Import Requisição API*/
import api from '../../api';

export default function Checkout() {
    const navigate = useNavigate();
    const { items, clearCart, updateQuantity, removeItem } = useCart();
    const { userId } = useAuth();

    const [etapa, setEtapa] = useState(1);
    const [enderecos, setEnderecos] = useState([]);
    const [enderecoSelecionado, setEnderecoSelecionado] = useState(null);
    const [cupomDesconto, setCupomDesconto] = useState('');
    const [cupomInfo, setCupomInfo] = useState(null);
    const [carregandoCupom, setCarregandoCupom] = useState(false);

    const [metodoPagamento, setMetodoPagamento] = useState('cartao');
    const [dadosCartao, setDadosCartao] = useState({
        numero: '',
        nome: '',
        validade: '',
        cvv: ''
    });
    const [mostrarVersoCartao, setMostrarVersoCartao] = useState(false);

    const [texto, setTexto] = useState('');
    const [acaoPosModal, setAcaoPosModal] = useState(null);
    const caixaDeDialogo = useRef(null);
    const caixaDeDialogoExcluir = useRef(null);
    const [processando, setProcessando] = useState(false);
    const [frete, setFrete] = useState(0);
    const [numeroPedido, setNumeroPedido] = useState(null);
    const [modalExcluirAberto, setModalExcluirAberto] = useState(false);
    const [idItemParaExcluir, setIdItemParaExcluir] = useState(null);

    // Gateway de pagamento
    const [gatewayConfig, setGatewayConfig] = useState(null);
    const [pixQrCode, setPixQrCode] = useState(null);
    const [pixQrCodeUrl, setPixQrCodeUrl] = useState(null);
    const [aguardandoPix, setAguardandoPix] = useState(false);

    const subtotal = items.reduce((sum, i) => sum + ((Number(i.preco) || 0) * i.quantidade), 0);
    const FRETE_GRATIS_MIN = 200;
    const freteGratis = subtotal >= FRETE_GRATIS_MIN;
    const faltaFrete = Math.max(FRETE_GRATIS_MIN - subtotal, 0);
    const progressoFrete = Math.min((subtotal / FRETE_GRATIS_MIN) * 100, 100);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
        caixaDeDialogoExcluir.current = document.getElementById('CaixaDeDialogoExcluirCheckout');
    }, []);

    // Buscar endereços do usuário logado
    useEffect(() => {
        const buscarEnderecos = async () => {
            if (!userId) return;
            try {
                const response = await api.get(`/clientes/${userId}`);
                if (response.data.success && response.data.cliente) {
                    setEnderecos(response.data.cliente.enderecos || []);
                }
            } catch (error) {
                console.error('Erro ao buscar endereços:', error);
            }
        };
        buscarEnderecos();
    }, [userId]);

    // Buscar status do gateway de pagamento
    useEffect(() => {
        const buscarGateway = async () => {
            try {
                const response = await api.get('/pagamento/config-status');
                if (response.data.success) {
                    setGatewayConfig(response.data);
                }
            } catch (error) {
                console.log('Gateway não configurado');
            }
        };
        buscarGateway();
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
        if (acaoPosModal) {
            acaoPosModal();
            setAcaoPosModal(null);
        }
    };

    const mostrarModal = () => {
        console.log('[mostrarModal] Abrindo modal com texto:', texto);
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
            console.log('[mostrarModal] Modal aberto');
        } else {
            console.error('[mostrarModal] caixaDeDialogo.current é null');
        }
    };

    const abrirModalExcluirItem = (idItem) => {
        setIdItemParaExcluir(idItem);
        setModalExcluirAberto(true);
        if (caixaDeDialogoExcluir.current) {
            caixaDeDialogoExcluir.current.showModal();
        }
    };

    const fecharModalExcluirItem = () => {
        if (caixaDeDialogoExcluir.current) {
            caixaDeDialogoExcluir.current.close();
        }
        setModalExcluirAberto(false);
        setIdItemParaExcluir(null);
    };

    const confirmarExcluirItem = () => {
        if (idItemParaExcluir != null) {
            removeItem(idItemParaExcluir);
        }
        fecharModalExcluirItem();
    };

    const somenteDigitos = (v) => v.replace(/\D/g, '');
    const formatarNumeroExibicao = (v) => {
        const limpo = somenteDigitos(v).slice(0, 16);
        const preenchimento = '################';
        const faltantes = preenchimento.slice(limpo.length, 16);
        const exib = (limpo + faltantes)
            .match(/.{1,4}/g)
            .join(' ');
        return exib.replace(/#/g, '•');
    };
    const formatarValidadeExibicao = (v) => {
        const limpo = somenteDigitos(v).slice(0, 4);
        const mm = limpo.slice(0, 2);
        const aa = limpo.slice(2, 4);
        return `${mm.padEnd(2, '•')}/${aa.padEnd(2, '•')}`;
    };

    const validarNumeroCartao = (numero) => {
        const digits = somenteDigitos(numero);
        if (digits.length < 13 || digits.length > 19) return false;
        let soma = 0;
        let alternar = false;
        for (let i = digits.length - 1; i >= 0; i--) {
            let n = parseInt(digits[i], 10);
            if (alternar) {
                n *= 2;
                if (n > 9) n -= 9;
            }
            soma += n;
            alternar = !alternar;
        }
        return soma % 10 === 0;
    };

    const validarValidade = (validade) => {
        const limpo = somenteDigitos(validade);
        if (limpo.length !== 4) return false;
        const mm = parseInt(limpo.slice(0, 2), 10);
        const aa = parseInt(limpo.slice(2, 4), 10);
        if (mm < 1 || mm > 12) return false;
        const agora = new Date();
        const anoAtual = Number(String(agora.getFullYear()).slice(-2));
        const mesAtual = agora.getMonth() + 1;
        if (aa < anoAtual) return false;
        if (aa === anoAtual && mm < mesAtual) return false;
        return true;
    };

    const mapMetodoPagamento = (metodo) => {
        if (metodo === 'cartao') return 'Cartão de Crédito';
        if (metodo === 'boleto') return 'Boleto';
        return 'Pix';
    };
    const handleCartaoChange = (e) => {
        const { name, value } = e.target;
        let novo = value;
        if (name === 'numero') novo = somenteDigitos(value).slice(0, 16);
        if (name === 'validade') novo = somenteDigitos(value).slice(0, 4);
        if (name === 'cvv') novo = somenteDigitos(value).slice(0, 4);
        setDadosCartao({ ...dadosCartao, [name]: novo });
    };

    const numeroCartaoExibicao = formatarNumeroExibicao(dadosCartao.numero);
    const nomeTitularExibicao = (dadosCartao.nome || 'NOME DO TITULAR').toUpperCase();
    const validadeExibicao = formatarValidadeExibicao(dadosCartao.validade);

    // Calcular frete via API ou fallback simples
    const [opcoesFreteAPI, setOpcoesFreteAPI] = useState([]);
    const [freteOpcaoSelecionada, setFreteOpcaoSelecionada] = useState(null);
    const [carregandoFrete, setCarregandoFrete] = useState(false);

    const calcularFrete = useCallback(() => {
        if (subtotal >= FRETE_GRATIS_MIN) return 0;
        if (freteOpcaoSelecionada !== null && opcoesFreteAPI.length > 0) {
            return Number(opcoesFreteAPI[freteOpcaoSelecionada]?.valor || 0);
        }
        const freteCalculado = Math.max(subtotal * 0.1, 15);
        return Number(freteCalculado.toFixed(2));
    }, [subtotal, freteOpcaoSelecionada, opcoesFreteAPI]);

    // Buscar opções de frete quando endereço é selecionado
    useEffect(() => {
        const buscarFrete = async () => {
            if (enderecoSelecionado === null) return;
            const endereco = enderecos[enderecoSelecionado];
            if (!endereco?.cep) return;

            setCarregandoFrete(true);
            try {
                const response = await api.post('/frete/calcular', {
                    cepDestino: endereco.cep.replace(/\D/g, '')
                });
                if (response.data.success && response.data.opcoes?.length > 0) {
                    setOpcoesFreteAPI(response.data.opcoes);
                    // Auto-select cheapest option
                    const maisBarato = response.data.opcoes.reduce((min, op, idx) =>
                        op.valor < response.data.opcoes[min].valor ? idx : min, 0
                    );
                    setFreteOpcaoSelecionada(maisBarato);
                }
            } catch (error) {
                console.log('Frete API indisponível, usando cálculo simplificado');
                setOpcoesFreteAPI([]);
            } finally {
                setCarregandoFrete(false);
            }
        };
        buscarFrete();
    }, [enderecoSelecionado, enderecos]);

    // Atualizar frete quando endereço muda
    useEffect(() => {
        if (enderecoSelecionado !== null) {
            const freteCalculado = calcularFrete();
            setFrete(freteCalculado);
        }
    }, [enderecoSelecionado, subtotal, calcularFrete]);

    const calcularDesconto = () => {
        if (!cupomInfo) return 0;
        if (cupomInfo.tipo_desconto === 'percentage') {
            return Number(((subtotal * Number(cupomInfo.valor_desconto)) / 100).toFixed(2));
        }
        return Number(Number(cupomInfo.valor_desconto).toFixed(2));
    };

    const gerarNumeroPedido = () => {
        const data = new Date();
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();
        const horas = String(data.getHours()).padStart(2, '0');
        const minutos = String(data.getMinutes()).padStart(2, '0');
        const segundos = String(data.getSeconds()).padStart(2, '0');
        const aleatorio = Math.random().toString(36).substring(2, 8).toUpperCase();
        return `PED-${ano}${mes}${dia}-${horas}${minutos}${segundos}-${aleatorio}`;
    };

    const descontoAplicado = calcularDesconto();
    const totalFinal = Math.max(Number((subtotal - descontoAplicado + frete).toFixed(2)), 0);

    const validarEndereco = () => enderecoSelecionado !== null;

    const validarPagamento = () => {
        if (metodoPagamento !== 'cartao') return true;
        if (!dadosCartao.numero || !dadosCartao.nome || !dadosCartao.validade || !dadosCartao.cvv) {
            setTexto('Preencha todos os dados do cartão.');
            mostrarModal();
            return false;
        }
        if (!validarNumeroCartao(dadosCartao.numero)) {
            setTexto('Número do cartão inválido.');
            mostrarModal();
            return false;
        }
        if (!validarValidade(dadosCartao.validade)) {
            setTexto('Validade do cartão inválida.');
            mostrarModal();
            return false;
        }
        if (dadosCartao.cvv.length < 3) {
            setTexto('CVV inválido.');
            mostrarModal();
            return false;
        }
        return true;
    };

    const proximaEtapa = () => {
        if (etapa === 1 && !validarEndereco()) {
            setTexto('Selecione um endereço de entrega antes de continuar.');
            mostrarModal();
            return;
        }
        if (etapa === 2 && !validarPagamento()) return;
        setEtapa((prev) => Math.min(prev + 1, 3));
    };

    const etapaAnterior = () => setEtapa((prev) => Math.max(prev - 1, 1));

    const aplicarCupom = async () => {
        const codigo = cupomDesconto.trim();
        if (!codigo) {
            setTexto('Digite um código de cupom válido.');
            mostrarModal();
            return;
        }
        setCarregandoCupom(true);
        try {
            const response = await api.post(`/cupom/validar/${codigo.toUpperCase()}`);
            if (response.data.success) {
                setCupomInfo(response.data.data);
                setTexto('Cupom aplicado com sucesso!');
                mostrarModal();
            } else {
                setCupomInfo(null);
                setTexto(response.data.message || 'Cupom inválido.');
                mostrarModal();
            }
        } catch (error) {
            setCupomInfo(null);
            // Handle 400 Bad Request as a validation error, not a network error
            if (error.response && error.response.status === 400) {
                setTexto(error.response.data?.message || 'Cupom inválido ou não encontrado.');
            } else {
                setTexto('Erro ao validar cupom. Tente novamente.');
            }
            mostrarModal();
        } finally {
            setCarregandoCupom(false);
        }
    };

    const removerCupom = () => {
        setCupomInfo(null);
        setCupomDesconto('');
        setTexto('Cupom removido com sucesso!');
        mostrarModal();
    };

    const finalizarPedido = async () => {
        if (!validarEndereco() || !validarPagamento()) return;
        
        // Validar estoque antes de finalizar
        const itensComEstoqueInsuficiente = items.filter(item => 
            Number(item.estoque) <= 0 || item.quantidade > Number(item.estoque)
        );
        
        if (itensComEstoqueInsuficiente.length > 0) {
            const nomesItens = itensComEstoqueInsuficiente.map(item => 
                `${item.nome} (Estoque: ${Number(item.estoque) || 0})`
            ).join(', ');
            setTexto(`Os seguintes itens estão com estoque insuficiente: ${nomesItens}. Atualize o carrinho antes de finalizar o pedido.`);
            mostrarModal();
            return;
        }
        
        setProcessando(true);

        try {
            // Generate order number
            const numPedido = gerarNumeroPedido();
            setNumeroPedido(numPedido);

            console.log('[finalizarPedido] items do carrinho:', items);
            const endereco = enderecos[enderecoSelecionado];
            const metodo = mapMetodoPagamento(metodoPagamento);
            const statusPagamento = (metodoPagamento === 'cartao' && gatewayConfig?.ativo) ? 'Processando' : (metodoPagamento === 'cartao' ? 'Pago' : 'Pendente');
            const dataPagamento = metodoPagamento === 'cartao' ? new Date().toISOString().split('T')[0] : null;
            const pedidoData = {
                numero_pedido: numPedido,
                itens: items.map(i => ({
                    id_produto: i.id_produto,
                    id_variacao: i.id,
                    quantidade: i.quantidade,
                    preco: Number(i.preco),
                    descricao_produto: i.nome,
                    url_img: i.imagem_principal
                })),
                desconto: descontoAplicado,
                frete: frete,
                metodo_pagamento: metodo,
                status_pagamento: statusPagamento,
                data_pagamento: dataPagamento,
                endereco_entrega: JSON.stringify(endereco),
                total: totalFinal
            };

            console.log('[finalizarPedido] pedidoData.itens:', pedidoData.itens);

            const response = await api.post('/pedidos', {
                pedido: pedidoData,
                clienteId: userId,
                usuarioId: userId,
                enderecoId: endereco?.id || null
            }, { withCredentials: true });

            console.log('[finalizarPedido] response.status:', response.status);
            console.log('[finalizarPedido] response.data:', response.data);

            const pedidoId = response.data?.id_pedido || response.data?.pedidoId;
            console.log('[finalizarPedido] pedidoId extraído:', pedidoId);

            if (response.status === 201 && pedidoId) {
                const destinoDetalhes = `/menu/perfil/meuspedidos/${pedidoId}`;

                // Process payment via gateway if active
                if (gatewayConfig?.ativo) {
                    try {
                        if (metodoPagamento === 'pix' && gatewayConfig.pix_habilitado) {
                            const pixResponse = await api.post('/pagamento/pix', {
                                pedidoId,
                                valor: totalFinal,
                                descricao: `Pedido ${numPedido} - Fracaro Store`
                            }, { withCredentials: true });

                            if (pixResponse.data.success) {
                                setPixQrCode(pixResponse.data.qr_code);
                                setPixQrCodeUrl(pixResponse.data.qr_code_url);
                                setAguardandoPix(true);

                                // Update payment status
                                await api.put(`/pedidos/${pedidoId}/pagamento`, {
                                    valor_pago: 0,
                                    status_pagamento: 'Pendente',
                                    data_pagamento: null,
                                    metodo_pagamento: 'Pix',
                                    usuarioId: userId
                                }, { withCredentials: true });

                                clearCart();
                                setProcessando(false);
                                return; // Stay on page showing PIX QR code
                            }
                        } else if (metodoPagamento === 'cartao' && gatewayConfig.cartao_habilitado) {
                            const cartaoResponse = await api.post('/pagamento/cartao', {
                                pedidoId,
                                valor: totalFinal,
                                dadosCartao: {
                                    numero: dadosCartao.numero,
                                    nome: dadosCartao.nome,
                                    validade: dadosCartao.validade,
                                    cvv: dadosCartao.cvv
                                },
                                parcelas: 1
                            }, { withCredentials: true });

                            if (cartaoResponse.data.success) {
                                await api.put(`/pedidos/${pedidoId}/pagamento`, {
                                    valor_pago: totalFinal,
                                    status_pagamento: 'Pago',
                                    data_pagamento: new Date().toISOString().split('T')[0],
                                    metodo_pagamento: 'Cartão de Crédito',
                                    usuarioId: userId
                                }, { withCredentials: true });

                                clearCart();
                                navigate(destinoDetalhes);
                                return;
                            } else {
                                setTexto(cartaoResponse.data.message || 'Erro no pagamento com cartão. Verifique os dados.');
                                mostrarModal();
                                setProcessando(false);
                                return;
                            }
                        }
                    } catch (paymentError) {
                        console.error('[finalizarPedido] Erro no gateway:', paymentError);
                        const payMsg = paymentError.response?.data?.message || 'Erro ao processar pagamento.';
                        // If gateway fails, still save order but with pending status
                        setTexto(`${payMsg} Seu pedido foi salvo. Você pode tentar pagar novamente.`);
                        mostrarModal();
                        
                        await api.put(`/pedidos/${pedidoId}/pagamento`, {
                            valor_pago: 0,
                            status_pagamento: 'Pendente',
                            data_pagamento: null,
                            metodo_pagamento: metodo,
                            usuarioId: userId
                        }, { withCredentials: true }).catch(() => {});

                        clearCart();
                        setAcaoPosModal(() => () => navigate(destinoDetalhes));
                        setProcessando(false);
                        return;
                    }
                }

                // Fallback: gateway not active, proceed normally
                console.log('[finalizarPedido] vai navegar para:', destinoDetalhes);
                
                await api.put(`/pedidos/${pedidoId}/pagamento`, {
                    valor_pago: metodoPagamento === 'cartao' ? totalFinal : 0,
                    status_pagamento: metodoPagamento === 'cartao' ? 'Pago' : 'Pendente',
                    data_pagamento: dataPagamento,
                    metodo_pagamento: metodo,
                    usuarioId: userId
                }, { withCredentials: true });

                clearCart();
                
                // Navega direto para a página de detalhes
                navigate(destinoDetalhes);
            } else {
                console.error('[finalizarPedido] Condição falhou - status:', response.status, 'pedidoId:', pedidoId);
            }
        } catch (error) {
            console.error('[finalizarPedido] Erro capturado:', error);
            console.error('[finalizarPedido] error.response:', error.response);
            const errorMessage = error.response?.data?.message || 'Erro ao finalizar pedido. Tente novamente.';
            setTexto(errorMessage);
            mostrarModal();
        } finally {
            setProcessando(false);
        }
    };

    if (items.length === 0) {
        return (
            <section className='container-Principal-Checkout'>
                <Cabecalho />
                <CookieAceite />
                <main>
                    <section className="conteudoMain">
                        <div className="checkout-empty">
                            <div className="empty-left">
                                <h1>Seu carrinho está vazio</h1>
                                <p>Que tal explorar nossos produtos e encontrar algo perfeito para você?</p>
                                <Link className="btn-voltar-compras" to="/produtos">Voltar às compras</Link>
                            </div>
                            <div className="empty-right">
                                <img src="/assets/image/imgTriste.svg" alt="Carrinho vazio - Fracaro Store" />
                            </div>
                        </div>
                    </section>
                </main>
                <Rodape />
            </section>
        );
    }

    return (
        <section className='container-Principal-Checkout'>
            <Cabecalho />
            <CookieAceite />
            <main>
                <section className="conteudoMain">
                    <dialog id="CaixaDeDialogo">
                        <div className='conteudo-dialog'>
                            <div className="dialog-texto">
                                <p>{texto}</p>
                                <button id="botao" onClick={fecharModal}>
                                    Ok
                                </button>
                            </div>
                        </div>
                    </dialog>
                    <dialog id="CaixaDeDialogoExcluirCheckout" className={modalExcluirAberto ? 'open' : ''}>
                        <div className='conteudo-dialog'>
                            <div className="dialog-texto">
                                <p>Você deseja excluir esse item do carrinho?</p>
                                <div className='bnts-decisao'>
                                    <button className="bnt-sim" onClick={confirmarExcluirItem}>
                                        Sim
                                    </button>
                                    <button className="bnt-nao" onClick={fecharModalExcluirItem}>
                                        Não
                                    </button>
                                </div>
                            </div>
                        </div>
                    </dialog>
                    <div className="checkout-container">
                        <h1>Checkout</h1>
                        <div className="checkout-wrapper">
                            {/* COLUNA ESQUERDA - ITENS DO PEDIDO FIXO */}
                            <div className="coluna-itens">
                                <div className="dados-pedido">
                                    <div className="cabecalho-pedido">
                                        <h2>
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3 8H21M5 3H20C21.1046 3 22 3.89543 22 5V20C22 21.1046 21.1046 22 20 22H5C3.89543 22 3 21.1046 3 20V5C3 3.89543 3.89543 3 5 3Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            Itens do Pedido
                                        </h2>
                                    </div>
                                    <div className="conteudo-pedido">
                                        <div className="itens-carrinho">
                                            {items.map((i, index) => {
                                                const atributos = [];
                                                if (i.cor) atributos.push(i.cor);
                                                if (i.tamanho) atributos.push(i.tamanho);
                                                if (i.tipo) atributos.push(i.tipo);
                                                if (i.material) atributos.push(i.material);
                                                const descricaoAtributos = atributos.join(' / ');

                                                return (
                                                <div key={`${i.id}-${index}`} className="item-carrinho">
                                                    <div className="imagem-produto" onClick={() => navigate(`/produto/${i.id_produto}`)} style={{cursor: 'pointer'}}>
                                                        <img src={i.imagem_principal} alt={i.nome} className="produto-imagem" />
                                                    </div>
                                                    <div className="detalhes-item">
                                                        <p><strong onClick={() => navigate(`/produto/${i.id_produto}`)} style={{cursor: 'pointer'}}>{i.nome}</strong></p>
                                                        <p className="qtd-item">Qtd: {i.quantidade} | {i.unidades_por_pacote} Unit. | {descricaoAtributos}</p>
                                                        <p className="preco-item">R$ {(Number(i.preco)).toFixed(2)} {i.unidades_por_pacote > 1 && (
                                                            <span className="preco-unitario-item"> | Preço Unit.: {formatarPrecoUnitario(i.preco, i.unidades_por_pacote)}</span>
                                                        )}</p>
                                                    </div>
                                                    <div className="subtotal-item">
                                                        <strong>R$ {(Number(i.preco) * i.quantidade).toFixed(2)}</strong>
                                                        <div className="controles-item">
                                                            <button className="bnt-mais" onClick={() => updateQuantity(i.id, +1)}>
                                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00065 0.958008C7.57565 0.958008 8.04232 1.42467 8.04232 1.99967V5.95801H12.0007C12.2769 5.95801 12.5419 6.06775 12.7372 6.2631C12.9326 6.45846 13.0423 6.72341 13.0423 6.99967C13.0423 7.27594 12.9326 7.54089 12.7372 7.73624C12.5419 7.93159 12.2769 8.04134 12.0007 8.04134H8.04232V11.9997C8.04232 12.2759 7.93257 12.5409 7.73722 12.7362C7.54187 12.9316 7.27692 13.0413 7.00065 13.0413C6.72438 13.0413 6.45943 12.9316 6.26408 12.7362C6.06873 12.5409 5.95898 12.2759 5.95898 11.9997V8.04134H2.00065C1.72438 8.04134 1.45943 7.93159 1.26408 7.73624C1.06873 7.54089 0.958984 7.27594 0.958984 6.99967C0.958984 6.72341 1.06873 6.45846 1.26408 6.2631C1.45943 6.06775 1.72438 5.95801 2.00065 5.95801H5.95898V1.99967C5.95898 1.42467 6.42565 0.958008 7.00065 0.958008Z" fill="white" /></svg>
                                                            </button>
                                                            <button className="bnt-menos" onClick={() => updateQuantity(i.id, -1)}>
                                                                <svg width="13" height="3" viewBox="0 0 13 3" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M1.38932 0H5.34766H11.3893C11.6656 0 11.9305 0.109747 12.1259 0.305097C12.3212 0.500447 12.431 0.765399 12.431 1.04167C12.431 1.31793 12.3212 1.58289 12.1259 1.77824C11.9305 1.97359 11.6656 2.08333 11.3893 2.08333H7.43099H1.38932C1.11306 2.08333 0.848104 1.97359 0.652753 1.77824C0.457403 1.58289 0.347656 1.31793 0.347656 1.04167C0.347656 0.765399 0.457403 0.500447 0.652753 0.305097C0.848104 0.109747 1.11306 0 1.38932 0Z" fill="white" /></svg>
                                                            </button>
                                                            <button className="bnt-excluir" onClick={() => abrirModalExcluirItem(i.id)}>
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" strokeWidth="2.08333" strokeLinecap="round" strokeLinejoin="round" stroke="white"  /></svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                            })}
                                        </div>
                                    </div>
                                    <div className="total-pedido">
                                        <p>Subtotal: <strong>R$ {subtotal.toFixed(2)}</strong></p>
                                        <p>Frete: <strong>{freteGratis ? 'Gratis' : `R$ ${frete.toFixed(2)}`}</strong></p>
                                        <div className="frete-progresso">
                                            <div className="frete-info">
                                                {freteGratis
                                                    ? 'Frete gratis liberado'
                                                    : `Faltam R$ ${faltaFrete.toFixed(2)} para frete gratis`}
                                            </div>
                                            <div className="frete-bar">
                                                <div className="frete-bar-fill" style={{ width: `${progressoFrete}%` }} />
                                            </div>
                                        </div>
                                        {descontoAplicado > 0 && (
                                            <p className="desconto-destaque">
                                                Desconto: <strong>- R$ {descontoAplicado.toFixed(2)}</strong>
                                            </p>
                                        )}
                                        <p className="total-final">Total: <strong>R$ {totalFinal.toFixed(2)}</strong></p>
                                    </div>
                                </div>
                            </div>

                            {/* COLUNA DIREITA - ENDEREÇO, CUPOM, PAGAMENTO */}
                            <div className="coluna-formulario">
                                <div className="checkout-steps">
                                    <div className={`step ${etapa === 1 ? 'active' : ''} ${etapa > 1 ? 'done' : ''}`}>
                                        <span className="step-number">1</span>
                                        <span className="step-label">Endereço</span>
                                    </div>
                                    <div className={`step ${etapa === 2 ? 'active' : ''} ${etapa > 2 ? 'done' : ''}`}>
                                        <span className="step-number">2</span>
                                        <span className="step-label">Pagamento</span>
                                    </div>
                                    <div className={`step ${etapa === 3 ? 'active' : ''}`}>
                                        <span className="step-number">3</span>
                                        <span className="step-label">Revisão</span>
                                    </div>
                                </div>

                                {/* SEÇÃO DE ENDEREÇO */}
                                {etapa === 1 && (
                                    <div className="dados-entrega">
                                    <div className="cabecalho-entrega">
                                        <h2>
                                            <svg width="39" height="31" viewBox="0 0 39 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M26.5 22.1425V5.5C26.5 4.57174 26.1313 3.6815 25.4749 3.02513C24.8185 2.36875 23.9283 2 23 2H5.5C4.57174 2 3.6815 2.36875 3.02513 3.02513C2.36875 3.6815 2 4.57174 2 5.5V21.25C2 21.7141 2.18437 22.1592 2.51256 22.4874C2.84075 22.8156 3.28587 23 3.75 23H4.9925C5.33363 22.2211 5.89434 21.5585 6.60607 21.0932C7.31779 20.6279 8.14968 20.3802 9 20.3802C9.85032 20.3802 10.6822 20.6279 11.3939 21.0932C12.1057 21.5585 12.6664 22.2211 13.0075 23H25.9925C26.1208 22.6908 26.29 22.405 26.5 22.1425ZM26.5 22.1425C26.9548 21.5256 27.5642 21.0396 28.2669 20.7335C28.9695 20.4273 29.7404 20.3119 30.5019 20.3989C31.2633 20.4859 31.9884 20.7721 32.6039 21.2288C33.2194 21.6855 33.7035 22.2964 34.0075 23H37V17.9425C37.0007 16.6726 36.6558 15.4264 36.0025 14.3375L33.85 10.75L32.2575 8.1075C32.1026 7.84626 31.8824 7.62983 31.6185 7.47949C31.3547 7.32914 31.0562 7.25005 30.7525 7.25H26.5V22.1425Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M17.75 14.25H9M17.75 9H9M13.375 24.75C13.3758 25.4008 13.2313 26.0436 12.9522 26.6316C12.673 27.2195 12.2662 27.7377 11.7614 28.1485C11.2566 28.5593 10.6665 28.8523 10.0341 29.0062C9.40176 29.16 8.74301 29.1708 8.10592 29.0378C7.46882 28.9048 6.86942 28.6313 6.35141 28.2373C5.83339 27.8433 5.40981 27.3387 5.11153 26.7602C4.81325 26.1818 4.64778 25.5441 4.62719 24.8936C4.6066 24.2431 4.7314 23.5962 4.9925 23C5.39535 22.0802 6.10238 21.3269 6.9949 20.8667C7.88742 20.4064 8.91109 20.2673 9.89409 20.4725C10.8771 20.6777 11.7596 21.2148 12.3934 21.9937C13.0272 22.7726 13.3738 23.7458 13.375 24.75ZM34.375 24.75C34.3758 25.4008 34.2313 26.0436 33.9522 26.6316C33.673 27.2195 33.2662 27.7377 32.7614 28.1485C32.2566 28.5593 31.6665 28.8523 31.0341 29.0062C30.4018 29.16 29.743 29.1708 29.1059 29.0378C28.4688 28.9048 27.8694 28.6313 27.3514 28.2373C26.8334 27.8433 26.4098 27.3387 26.1115 26.7602C25.8132 26.1818 25.6478 25.5441 25.6272 24.8936C25.6066 24.2431 25.7314 23.5962 25.9925 23C26.1208 22.6908 26.29 22.405 26.5 22.1425C26.9548 21.5256 27.5642 21.0396 28.2669 20.7335C28.9695 20.4273 29.7404 20.3119 30.5019 20.3989C31.2633 20.4859 31.9884 20.7721 32.6039 21.2288C33.2194 21.6855 33.7035 22.2964 34.0075 23C34.2525 23.5512 34.3785 24.148 34.375 24.75Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            Endereço de Entrega
                                        </h2>
                                    </div>
                                    <div className="conteudo-entrega">
                                        <div className="selecionar-endereco">
                                            <div className="caixas-endereco">
                                                {enderecos.length === 0 ? (
                                                    <p className='nenhum-endereco'>Não há endereços cadastrados.</p>
                                                ) : (
                                                    enderecos.map((end, idx) => (
                                                        <div
                                                            key={idx}
                                                            className={`endereco-item ${enderecoSelecionado === idx ? 'selecionado' : ''}`}
                                                            onClick={() => setEnderecoSelecionado(idx)}
                                                        >
                                                            <div className='endereco-esquerda'>
                                                                <input
                                                                    type="radio"
                                                                    name="endereco"
                                                                    checked={enderecoSelecionado === idx}
                                                                    onChange={() => setEnderecoSelecionado(idx)}
                                                                />
                                                                <p>
                                                                    {end.logradouro}, {end.numero}
                                                                    {end.complemento && `, ${end.complemento}`}<br />
                                                                    {end.bairro}, {end.cidade}/{end.estado}<br />
                                                                    CEP {end.cep}
                                                                </p>
                                                            </div>
                                                            <div className='endereco-direita'>
                                                                <div>
                                                                    <button
                                                                        type="button"
                                                                        className='btn-editar-endereco'
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            navigate('/menu/perfil/alterarendereco', { state: { idEndereco: end.id } });
                                                                        }}
                                                                        title="Editar endereço"
                                                                    >
                                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.4999 5.00007L14.9999 7.50007M10.8333 16.6667H17.4999M4.16659 13.3334L3.33325 16.6667L6.66659 15.8334L16.3216 6.17841C16.634 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.634 4.13429 16.3216 3.82174L16.1783 3.67841C15.8657 3.36596 15.4419 3.19043 14.9999 3.19043C14.558 3.19043 14.1341 3.36596 13.8216 3.67841L4.16659 13.3334Z" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /></svg>
                                                                    </button>
                                                                </div>
                                                                <div className={`endereco-selecionado-icon ${enderecoSelecionado === idx ? ' selecionado' : ''}`}>
                                                                    <svg width="39" height="31" viewBox="0 0 39 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.5 22.1425V5.5C26.5 4.57174 26.1313 3.6815 25.4749 3.02513C24.8185 2.36875 23.9283 2 23 2H5.5C4.57174 2 3.6815 2.36875 3.02513 3.02513C2.36875 3.6815 2 4.57174 2 5.5V21.25C2 21.7141 2.18437 22.1592 2.51256 22.4874C2.84075 22.8156 3.28587 23 3.75 23H4.9925C5.33363 22.2211 5.89434 21.5585 6.60607 21.0932C7.31779 20.6279 8.14968 20.3802 9 20.3802C9.85032 20.3802 10.6822 20.6279 11.3939 21.0932C12.1057 21.5585 12.6664 22.2211 13.0075 23H25.9925C26.1208 22.6908 26.29 22.405 26.5 22.1425ZM26.5 22.1425C26.9548 21.5256 27.5642 21.0396 28.2669 20.7335C28.9695 20.4273 29.7404 20.3119 30.5019 20.3989C31.2633 20.4859 31.9884 20.7721 32.6039 21.2288C33.2194 21.6855 33.7035 22.2964 34.0075 23H37V17.9425C37.0007 16.6726 36.6558 15.4264 36.0025 14.3375L33.85 10.75L32.2575 8.1075C32.1026 7.84626 31.8824 7.62983 31.6185 7.47949C31.3547 7.32914 31.0562 7.25005 30.7525 7.25H26.5V22.1425Z" stroke="#131C46" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" /><path d="M20.207 6.5C20.5323 6.50004 20.8514 6.61919 21.0928 6.8418C21.3354 7.06569 21.4805 7.37842 21.4805 7.71387C21.4804 8.04926 21.3354 8.3621 21.0928 8.58594L12.8838 16.1582C12.3897 16.614 11.6054 16.614 11.1113 16.1582L7.86816 13.166C7.74831 13.0554 7.65034 12.9224 7.58301 12.7725C7.51559 12.6223 7.48047 12.4592 7.48047 12.2939C7.48057 11.9586 7.62552 11.6457 7.86816 11.4219C8.10947 11.1994 8.42873 11.0811 8.75391 11.0811C9.07906 11.0811 9.39832 11.1995 9.63965 11.4219L11.9932 13.5928L19.3213 6.8418C19.5626 6.61921 19.8817 6.5 20.207 6.5Z" fill="#28A745" stroke="#28A745" /><path d="M13.375 24.7503C13.3758 25.4012 13.2313 26.044 12.9522 26.6319C12.673 27.2198 12.2662 27.7381 11.7614 28.1489C11.2566 28.5597 10.6665 28.8527 10.0341 29.0065C9.40176 29.1604 8.74301 29.1712 8.10592 29.0382C7.46882 28.9052 6.86942 28.6317 6.35141 28.2377C5.83339 27.8437 5.40981 27.339 5.11153 26.7606C4.81325 26.1821 4.64778 25.5444 4.62719 24.8939C4.6066 24.2434 4.7314 23.5965 4.9925 23.0003C5.39535 22.0805 6.10238 21.3273 6.9949 20.867C7.88742 20.4068 8.91109 20.2676 9.89409 20.4728C10.8771 20.678 11.7596 21.2152 12.3934 21.9941C13.0272 22.7729 13.3738 23.7462 13.375 24.7503ZM34.375 24.7503C34.3758 25.4012 34.2313 26.044 33.9522 26.6319C33.673 27.2198 33.2662 27.7381 32.7614 28.1489C32.2566 28.5597 31.6665 28.8527 31.0341 29.0065C30.4018 29.1604 29.743 29.1712 29.1059 29.0382C28.4688 28.9052 27.8694 28.6317 27.3514 28.2377C26.8334 27.8437 26.4098 27.339 26.1115 26.7606C25.8132 26.1821 25.6478 25.5444 25.6272 24.8939C25.6066 24.2434 25.7314 23.5965 25.9925 23.0003C26.1208 22.6912 26.29 22.4053 26.5 22.1428C26.9548 21.526 27.5642 21.0399 28.2669 20.7338C28.9695 20.4277 29.7404 20.3123 30.5019 20.3992C31.2633 20.4862 31.9884 20.7725 32.6039 21.2292C33.2194 21.6859 33.7035 22.2968 34.0075 23.0003C34.2525 23.5516 34.3785 24.1483 34.375 24.7503Z" stroke="#131C46" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" /></svg>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                )}
                                            </div>

                                            <button
                                                type="button"
                                                className='btn-adicionar-endereco'
                                                onClick={() => navigate('/menu/perfil/cadastroendereco')}
                                            >
                                                + Adicionar novo endereço
                                            </button>
                                        </div>

                                        {/* Opções de Frete */}
                                        {enderecoSelecionado !== null && !freteGratis && (
                                            <div className="opcoes-frete-section">
                                                <h3>Opções de Entrega</h3>
                                                {carregandoFrete ? (
                                                    <p className="carregando-frete">Calculando frete...</p>
                                                ) : opcoesFreteAPI.length > 0 ? (
                                                    <div className="opcoes-frete-list">
                                                        {opcoesFreteAPI.map((opcao, idx) => (
                                                            <label
                                                                key={idx}
                                                                className={`opcao-frete ${freteOpcaoSelecionada === idx ? 'selecionado' : ''}`}
                                                                onClick={() => setFreteOpcaoSelecionada(idx)}
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    name="frete"
                                                                    checked={freteOpcaoSelecionada === idx}
                                                                    onChange={() => setFreteOpcaoSelecionada(idx)}
                                                                />
                                                                <div className="frete-info">
                                                                    <strong>{opcao.nome}</strong>
                                                                    <span>{opcao.prazo}</span>
                                                                </div>
                                                                <span className="frete-valor">
                                                                    {opcao.valor === 0 ? 'Grátis' : `R$ ${Number(opcao.valor).toFixed(2)}`}
                                                                </span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="frete-fallback">Frete: R$ {frete.toFixed(2)}</p>
                                                )}
                                            </div>
                                        )}
                                        {enderecoSelecionado !== null && freteGratis && (
                                            <div className="opcoes-frete-section">
                                                <h3>
                                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1 3H16V16H1V3Z" stroke="#131C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M16 8H20L23 11V16H16V8Z" stroke="#131C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <circle cx="5.5" cy="18.5" r="2.5" stroke="#131C46" strokeWidth="2"/>
                                                        <circle cx="18.5" cy="18.5" r="2.5" stroke="#131C46" strokeWidth="2"/>
                                                    </svg>
                                                    Frete Grátis!
                                                </h3>
                                                <p className="frete-gratis-msg">Sua compra se qualifica para frete gratuito.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                )}



                                {/* SEÇÃO DE PAGAMENTO */}
                                {etapa === 2 && (
                                    <div className="dados-pagamento">
                                    <div className="cabecalho-pagamento">
                                        <h2>
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2 6H22M4 3H20C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <circle cx="5" cy="15" r="1.5" fill="white" />
                                            </svg>
                                            Método de Pagamento
                                        </h2>
                                    </div>
                                    <div className="conteudo-pagamento">
                                    <div className="ssl-badges">
                                        <div>
                                            <span><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.99992 18.3333C4.54159 18.3333 4.14936 18.1703 3.82325 17.8441C3.49714 17.518 3.33381 17.1255 3.33325 16.6666V8.33331C3.33325 7.87498 3.49659 7.48276 3.82325 7.15665C4.14992 6.83054 4.54214 6.6672 4.99992 6.66665H5.83325V4.99998C5.83325 3.8472 6.23964 2.8647 7.05242 2.05248C7.8652 1.24026 8.8477 0.833869 9.99992 0.833314C11.1521 0.832758 12.1349 1.23915 12.9483 2.05248C13.7616 2.86581 14.1677 3.84831 14.1666 4.99998V6.66665H14.9999C15.4583 6.66665 15.8508 6.82998 16.1774 7.15665C16.5041 7.48331 16.6671 7.87554 16.6666 8.33331V16.6666C16.6666 17.125 16.5035 17.5175 16.1774 17.8441C15.8513 18.1708 15.4588 18.3339 14.9999 18.3333H4.99992ZM4.99992 16.6666H14.9999V8.33331H4.99992V16.6666ZM11.1774 13.6766C11.5035 13.3511 11.6666 12.9589 11.6666 12.5C11.6666 12.0411 11.5035 11.6489 11.1774 11.3233C10.8513 10.9978 10.4588 10.8344 9.99992 10.8333C9.54103 10.8322 9.14881 10.9955 8.82325 11.3233C8.4977 11.6511 8.33436 12.0433 8.33325 12.5C8.33214 12.9566 8.49547 13.3491 8.82325 13.6775C9.15103 14.0058 9.54325 14.1689 9.99992 14.1666C10.4566 14.1644 10.8491 14.0005 11.1774 13.6766ZM7.49992 6.66665H12.4999V4.99998C12.4999 4.30554 12.2569 3.71526 11.7708 3.22915C11.2846 2.74304 10.6944 2.49998 9.99992 2.49998C9.30547 2.49998 8.7152 2.74304 8.22909 3.22915C7.74297 3.71526 7.49992 4.30554 7.49992 4.99998V6.66665Z" fill="#131C46"/></svg></span>
                                            <p>Conexão Segura</p>
                                        </div>
                                        <div>
                                            <span><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72909 18.2292C9.64575 18.2153 9.56242 18.1945 9.47909 18.1667C7.60409 17.5417 6.11103 16.3853 4.99992 14.6975C3.88881 13.0097 3.33325 11.1939 3.33325 9.25002V5.31252C3.33325 4.9653 3.43409 4.6528 3.63575 4.37502C3.83742 4.09724 4.0977 3.89585 4.41659 3.77085L9.41659 1.89585C9.61103 1.82641 9.80547 1.79169 9.99992 1.79169C10.1944 1.79169 10.3888 1.82641 10.5833 1.89585L15.5833 3.77085C15.9027 3.89585 16.1633 4.09724 16.3649 4.37502C16.5666 4.6528 16.6671 4.9653 16.6666 5.31252V9.25002C16.6666 11.1945 16.111 13.0106 14.9999 14.6984C13.8888 16.3861 12.3958 17.5422 10.5208 18.1667C10.4374 18.1945 10.3541 18.2153 10.2708 18.2292C10.1874 18.2431 10.0971 18.25 9.99992 18.25C9.9027 18.25 9.81242 18.2431 9.72909 18.2292ZM9.99992 16.5834C11.4444 16.125 12.6388 15.2084 13.5833 13.8334C14.5277 12.4584 14.9999 10.9306 14.9999 9.25002V5.31252L9.99992 3.43752L4.99992 5.31252V9.25002C4.99992 10.9306 5.47214 12.4584 6.41659 13.8334C7.36103 15.2084 8.55547 16.125 9.99992 16.5834Z" fill="#131C46"/></svg></span>
                                            <p>Dados Protegidos</p>
                                        </div>
                                        <div>
                                            <span><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.82164 1.75002C9.11663 1.45542 9.51132 1.28207 9.92784 1.26417C10.3444 1.24628 10.7525 1.38514 11.0716 1.65336L11.1783 1.75086L12.7616 3.33336H15C15.4203 3.33343 15.8251 3.49233 16.1332 3.77822C16.4414 4.06411 16.6301 4.45587 16.6616 4.87502L16.6666 5.00002V7.23836L18.25 8.82169C18.5448 9.11672 18.7183 9.51158 18.7362 9.9283C18.7541 10.345 18.6151 10.7533 18.3466 11.0725L18.2491 11.1784L16.6658 12.7617V15C16.6659 15.4205 16.5071 15.8255 16.2212 16.1338C15.9353 16.4421 15.5434 16.631 15.1241 16.6625L15 16.6667H12.7625L11.1791 18.25C10.8841 18.5449 10.4892 18.7184 10.0725 18.7363C9.65581 18.7542 9.24753 18.6151 8.92831 18.3467L8.82248 18.25L7.23914 16.6667H4.99998C4.57949 16.6668 4.1745 16.508 3.86619 16.2221C3.55787 15.9362 3.36901 15.5443 3.33748 15.125L3.33331 15V12.7617L1.74998 11.1784C1.45514 10.8833 1.28164 10.4885 1.26374 10.0717C1.24585 9.65503 1.38485 9.24675 1.65331 8.92752L1.74998 8.82169L3.33331 7.23836V5.00002C3.33339 4.57969 3.49228 4.1749 3.77817 3.86676C4.06406 3.55862 4.45582 3.36988 4.87498 3.33836L4.99998 3.33336H7.23831L8.82164 1.75002ZM9.99998 2.93002L8.41664 4.51336C8.13983 4.78973 7.77463 4.95994 7.38498 4.99419L7.23831 5.00002H4.99998V7.23836C5.00008 7.62993 4.8623 8.00904 4.61081 8.30919L4.51164 8.41752L2.92831 10.0009L4.51164 11.5834C4.78832 11.86 4.95884 12.2253 4.99331 12.615L4.99998 12.7617V15H7.23831C7.62989 14.9999 8.009 15.1377 8.30914 15.3892L8.41748 15.4884L9.99998 17.0717L11.5833 15.4884C11.86 15.2117 12.2252 15.0412 12.615 15.0067L12.7616 15H15V12.7617C14.9999 12.3701 15.1377 11.991 15.3891 11.6909L15.4883 11.5825L17.0716 10L15.4883 8.41669C15.2116 8.14 15.0411 7.77479 15.0066 7.38502L15 7.23836V5.00002H12.7616C12.3701 5.00012 11.991 4.86234 11.6908 4.61086L11.5825 4.51169L9.99914 2.92836L9.99998 2.93002ZM12.5666 7.48669C12.7166 7.33723 12.9178 7.25046 13.1295 7.244C13.3411 7.23754 13.5472 7.31187 13.706 7.4519C13.8648 7.59192 13.9644 7.78715 13.9845 7.99792C14.0046 8.20869 13.9437 8.4192 13.8141 8.58669L13.7441 8.66502L9.67748 12.7317C9.5187 12.8907 9.30707 12.9858 9.08278 12.999C8.85848 13.0122 8.63715 12.9426 8.46081 12.8034L8.38081 12.7325L6.37748 10.7292C6.22643 10.5796 6.13828 10.3779 6.13107 10.1654C6.12386 9.95292 6.19814 9.74572 6.3387 9.5862C6.47925 9.42669 6.67546 9.32694 6.88716 9.30735C7.09886 9.28777 7.31004 9.34984 7.47747 9.48085L7.55581 9.55002L9.02914 11.0234L12.5666 7.48669Z" fill="#131C46"/></svg></span>
                                            <p>Certificado SSL</p>
                                        </div>
                                    </div>
                                        <div className="metodo-pagamento-container">
                                            <label className="opcao-pagamento">
                                                <input
                                                    type="radio"
                                                    value="cartao"
                                                    checked={metodoPagamento === 'cartao'}
                                                    onChange={(e) => setMetodoPagamento(e.target.value)}
                                                />
                                                <span><svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.16667 8.33333H6.66667C6.88768 8.33333 7.09964 8.24554 7.25592 8.08926C7.4122 7.93297 7.5 7.72101 7.5 7.5C7.5 7.27899 7.4122 7.06702 7.25592 6.91074C7.09964 6.75446 6.88768 6.66667 6.66667 6.66667H4.16667C3.94565 6.66667 3.73369 6.75446 3.57741 6.91074C3.42113 7.06702 3.33333 7.27899 3.33333 7.5C3.33333 7.72101 3.42113 7.93297 3.57741 8.08926C3.73369 8.24554 3.94565 8.33333 4.16667 8.33333ZM14.1667 0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5V10C0 10.663 0.263392 11.2989 0.732233 11.7678C1.20107 12.2366 1.83696 12.5 2.5 12.5H14.1667C14.8297 12.5 15.4656 12.2366 15.9344 11.7678C16.4033 11.2989 16.6667 10.663 16.6667 10V2.5C16.6667 1.83696 16.4033 1.20107 15.9344 0.732233C15.4656 0.263392 14.8297 0 14.1667 0ZM15 10C15 10.221 14.9122 10.433 14.7559 10.5893C14.5996 10.7455 14.3877 10.8333 14.1667 10.8333H2.5C2.27899 10.8333 2.06702 10.7455 1.91074 10.5893C1.75446 10.433 1.66667 10.221 1.66667 10V5H15V10ZM15 3.33333H1.66667V2.5C1.66667 2.27899 1.75446 2.06702 1.91074 1.91074C2.06702 1.75446 2.27899 1.66667 2.5 1.66667H14.1667C14.3877 1.66667 14.5996 1.75446 14.7559 1.91074C14.9122 2.06702 15 2.27899 15 2.5V3.33333Z" fill="#131C46" /></svg> Cartão de Crédito</span>
                                            </label>
                                            <label className="opcao-pagamento">
                                                <input
                                                    type="radio"
                                                    value="boleto"
                                                    checked={metodoPagamento === 'boleto'}
                                                    onChange={(e) => setMetodoPagamento(e.target.value)}
                                                />
                                                <span><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 42V0H3.72727V42H0ZM5.59091 42V0H9.31818V42H5.59091ZM11.1818 42V0H13.0455V42H11.1818ZM16.7727 42V0H20.5V42H16.7727ZM22.3636 42V0H27.9545V42H22.3636ZM29.8182 42V0H31.6818V42H29.8182ZM35.4091 42V0H41V42H35.4091Z" fill="#131C46" /></svg> Boleto Bancário</span>
                                            </label>
                                            <label className="opcao-pagamento">
                                                <input
                                                    type="radio"
                                                    value="pix"
                                                    checked={metodoPagamento === 'pix'}
                                                    onChange={(e) => setMetodoPagamento(e.target.value)}
                                                />
                                                <span><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.4859 29.9391C29.732 29.9419 28.9851 29.795 28.2883 29.507C27.5915 29.2191 26.9586 28.7957 26.4261 28.2614L20.5618 22.3861C20.3544 22.1875 20.0785 22.0767 19.7915 22.0767C19.5045 22.0767 19.2286 22.1875 19.0212 22.3861L13.1371 28.2775C12.6049 28.8126 11.9722 29.2368 11.2754 29.5256C10.5785 29.8145 9.83145 29.9622 9.07728 29.9602H7.9292L15.3602 37.4004C16.4747 38.5139 17.9848 39.1393 19.5593 39.1393C21.1337 39.1393 22.6439 38.5139 23.7584 37.4004L31.2042 29.9441L30.4859 29.9391Z" fill="#131C46" /><path d="M9.07852 9.17596C9.8327 9.17395 10.5798 9.32162 11.2766 9.61045C11.9735 9.89928 12.6062 10.3235 13.1383 10.8587L19.0224 16.7513C19.2269 16.9555 19.5039 17.0701 19.7927 17.0701C20.0815 17.0701 20.3585 16.9555 20.5631 16.7513L26.4261 10.881C26.9578 10.3452 27.5904 9.92041 28.2873 9.63134C28.9842 9.34226 29.7315 9.19464 30.4859 9.19705H31.1918L23.746 1.74195C23.1946 1.1897 22.54 0.751616 21.8195 0.452727C21.099 0.153838 20.3268 0 19.5469 0C18.767 0 17.9948 0.153838 17.2743 0.452727C16.5538 0.751616 15.8991 1.1897 15.3478 1.74195L7.9292 9.17596H9.07852Z" fill="#131C46" /><path d="M37.3509 15.365L32.8514 10.8599C32.7499 10.9015 32.6415 10.9233 32.5319 10.9244H30.4859C29.4212 10.9271 28.4006 11.3504 27.646 12.1024L21.783 17.9691C21.255 18.4968 20.5394 18.7932 19.7933 18.7932C19.0473 18.7932 18.3317 18.4968 17.8037 17.9691L11.9184 12.0801C11.164 11.3277 10.1434 10.9038 9.07851 10.9008H6.56684C6.46333 10.8985 6.36104 10.8779 6.26465 10.8401L1.73671 15.365C0.624587 16.4809 0 17.9929 0 19.5693C0 21.1457 0.624587 22.6578 1.73671 23.7737L6.25474 28.2973C6.35092 28.2587 6.45334 28.2382 6.55693 28.2365H9.07851C10.1433 28.2334 11.1639 27.8096 11.9184 27.0573L17.8025 21.1659C18.8663 20.1019 20.7204 20.1019 21.783 21.1659L27.646 27.035C28.4006 27.787 29.4212 28.2103 30.4859 28.213H32.5319C32.6415 28.2138 32.75 28.2356 32.8514 28.2775L37.3509 23.7724C37.9024 23.2204 38.34 22.5649 38.6385 21.8435C38.937 21.1221 39.0906 20.3489 39.0906 19.5681C39.0906 18.7872 38.937 18.014 38.6385 17.2926C38.34 16.5712 37.9024 15.9158 37.3509 15.3637" fill="#131C46" /></svg> Pix</span>
                                            </label>
                                        </div>

                                        {metodoPagamento === 'cartao' && (
                                            <div className="dados-cartao">
                                                <div className={`cartao-visual ${mostrarVersoCartao ? 'flip' : ''}`}>
                                                    <div className="cartao">
                                                        <div className="face frente">
                                                            <div className="detalhe topo">
                                                                <div className="bandeira" aria-hidden="true"></div>
                                                            </div>
                                                            <div className="chip" aria-hidden="true"></div>
                                                            <div className="numero" aria-label="Número do cartão">
                                                                {numeroCartaoExibicao}
                                                            </div>
                                                            <div className="linha-inferior">
                                                                <div className="titular">
                                                                    <label>Nome</label>
                                                                    <span>{nomeTitularExibicao}</span>
                                                                </div>
                                                                <div className="validade">
                                                                    <label>Validade</label>
                                                                    <span>{validadeExibicao}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="face verso">
                                                            <div className="tarja" aria-hidden="true"></div>
                                                            <div className="cvv-box">
                                                                <label>CVV</label>
                                                                <span>{(somenteDigitos(dadosCartao.cvv) || '•••')}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label>Número do Cartão:</label>
                                                        <input
                                                            type="text"
                                                            name="numero"
                                                            value={dadosCartao.numero}
                                                            onChange={handleCartaoChange}
                                                            onFocus={() => setMostrarVersoCartao(false)}
                                                            placeholder="0000 0000 0000 0000"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label>Nome no Cartão:</label>
                                                        <input
                                                            type="text"
                                                            name="nome"
                                                            value={dadosCartao.nome}
                                                            onChange={handleCartaoChange}
                                                            onFocus={() => setMostrarVersoCartao(false)}
                                                            placeholder="Nome Completo"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label>Validade:</label>
                                                        <input
                                                            type="text"
                                                            name="validade"
                                                            value={dadosCartao.validade}
                                                            onChange={handleCartaoChange}
                                                            onFocus={() => setMostrarVersoCartao(false)}
                                                            placeholder="MM/AA"
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label>CVV:</label>
                                                        <input
                                                            type="text"
                                                            name="cvv"
                                                            value={dadosCartao.cvv}
                                                            onChange={handleCartaoChange}
                                                            onFocus={() => setMostrarVersoCartao(true)}
                                                            onBlur={() => setMostrarVersoCartao(false)}
                                                            placeholder="000"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {metodoPagamento === 'pix' && (
                                            <div className="info-pix">
                                                <p>Você receberá um código PIX para escanear após confirmar o pedido.</p>
                                            </div>
                                        )}

                                        {metodoPagamento === 'boleto' && (
                                            <div className="info-boleto">
                                                <p>O boleto será enviado para seu email.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                )}

                                {/* SEÇÃO DE CUPOM DE DESCONTO */}
                                {etapa === 2 && (
                                    <div className="dados-cupom">
                                    <div className="cabecalho-cupom">
                                        <h2>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.3334 6.66665L13.3334 7.66665L7.66675 13.3333L6.66675 12.3333L12.3334 6.66665ZM3.33341 3.33331H16.6667C17.5917 3.33331 18.3334 4.07498 18.3334 4.99998V8.33331C17.8914 8.33331 17.4675 8.50891 17.1549 8.82147C16.8423 9.13403 16.6667 9.55795 16.6667 9.99998C16.6667 10.442 16.8423 10.8659 17.1549 11.1785C17.4675 11.4911 17.8914 11.6666 18.3334 11.6666V15C18.3334 15.925 17.5917 16.6666 16.6667 16.6666H3.33341C2.89139 16.6666 2.46746 16.4911 2.1549 16.1785C1.84234 15.8659 1.66675 15.442 1.66675 15V11.6666C2.59175 11.6666 3.33341 10.925 3.33341 9.99998C3.33341 9.55795 3.15782 9.13403 2.84526 8.82147C2.5327 8.50891 2.10878 8.33331 1.66675 8.33331V4.99998C1.66675 4.55795 1.84234 4.13403 2.1549 3.82147C2.46746 3.50891 2.89139 3.33331 3.33341 3.33331ZM3.33341 4.99998V7.11665C3.83981 7.40865 4.26038 7.82886 4.55279 8.33502C4.84521 8.84118 4.99916 9.41543 4.99916 9.99998C4.99916 10.5845 4.84521 11.1588 4.55279 11.6649C4.26038 12.1711 3.83981 12.5913 3.33341 12.8833V15H16.6667V12.8833C16.1603 12.5913 15.7398 12.1711 15.4474 11.6649C15.155 11.1588 15.001 10.5845 15.001 9.99998C15.001 9.41543 15.155 8.84118 15.4474 8.33502C15.7398 7.82886 16.1603 7.40865 16.6667 7.11665V4.99998H3.33341ZM7.91675 6.66665C8.60841 6.66665 9.16675 7.22498 9.16675 7.91665C9.16675 8.60831 8.60841 9.16665 7.91675 9.16665C7.22508 9.16665 6.66675 8.60831 6.66675 7.91665C6.66675 7.22498 7.22508 6.66665 7.91675 6.66665ZM12.0834 10.8333C12.7751 10.8333 13.3334 11.3916 13.3334 12.0833C13.3334 12.775 12.7751 13.3333 12.0834 13.3333C11.3917 13.3333 10.8334 12.775 10.8334 12.0833C10.8334 11.3916 11.3917 10.8333 12.0834 10.8333Z" fill='#fff'/></svg>
                                            Cupom de Desconto
                                        </h2>
                                    </div>
                                    <div className="conteudo-cupom">
                                        <div className="cupom-input-group">
                                            <input
                                                type="text"
                                                placeholder="Digite seu código de cupom"
                                                value={cupomDesconto}
                                                onChange={(e) => setCupomDesconto(e.target.value)}
                                            />
                                            <button type="button" className='btn-aplicar-cupom' onClick={aplicarCupom} disabled={carregandoCupom}>
                                                {carregandoCupom ? 'Aplicando...' : 'Aplicar'}
                                            </button>
                                        </div>
                                        {cupomInfo && (
                                            <div className="cupom-aplicado-container">
                                                <p className="cupom-aplicado">✓ Cupom aplicado: <strong>{cupomInfo.codigo}</strong></p>
                                                <button type="button" className='btn-remover-cupom' onClick={removerCupom}>
                                                    ✕ Remover
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                )}

                                {etapa === 3 && (
                                    <div className="dados-revisao">
                                        <div className="cabecalho-revisao">
                                            <h2>
                                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V6L14 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M14 2V6H18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M8 13L10 15L14 11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                                Revisar Pedido
                                            </h2>
                                        </div>
                                        <div className="conteudo-revisao">
                                            <div className="resumo-item">
                                                <strong>Endereço:</strong>
                                                <p>
                                                    {enderecos[enderecoSelecionado]?.logradouro}, {enderecos[enderecoSelecionado]?.numero}
                                                    {enderecos[enderecoSelecionado]?.complemento && `, ${enderecos[enderecoSelecionado]?.complemento}`}
                                                    <br />
                                                    {enderecos[enderecoSelecionado]?.bairro}, {enderecos[enderecoSelecionado]?.cidade}/{enderecos[enderecoSelecionado]?.estado}
                                                    <br />
                                                    CEP {enderecos[enderecoSelecionado]?.cep}
                                                </p>
                                            </div>
                                            <div className="resumo-item">
                                                <strong>Pagamento:</strong>
                                                <p>{mapMetodoPagamento(metodoPagamento)}</p>
                                            </div>
                                            {cupomInfo && (
                                                <div className="resumo-item">
                                                    <strong>Cupom:</strong>
                                                    <p>{cupomInfo.codigo} (- R$ {descontoAplicado.toFixed(2)})</p>
                                                </div>
                                            )}
                                            <div className="resumo-item">
                                                <strong>Total:</strong>
                                                <p>R$ {totalFinal.toFixed(2)}</p>
                                            </div>
                                            {numeroPedido && (
                                                <div className="numero-pedido-box">
                                                    <p className="numero-label">Número do Pedido</p>
                                                    <p className="numero-valor">{numeroPedido}</p>
                                                    <button
                                                        type="button"
                                                        className="numero-copiar"
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(numeroPedido);
                                                            setTexto('Número de pedido copiado para a área de transferência!');
                                                            mostrarModal();
                                                        }}
                                                    >
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                                                            <path d="M3 11V3H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                        Copiar
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* PIX QR CODE - shown after order is placed with PIX */}
                                {aguardandoPix && (
                                    <div className="pix-qrcode-container">
                                        <div className="pix-header">
                                            <h2>
                                                <svg width="22" height="22" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M30.4859 29.9391C29.732 29.9419 28.9851 29.795 28.2883 29.507C27.5915 29.2191 26.9586 28.7957 26.4261 28.2614L20.5618 22.3861C20.3544 22.1875 20.0785 22.0767 19.7915 22.0767C19.5045 22.0767 19.2286 22.1875 19.0212 22.3861L13.1371 28.2775C12.6049 28.8126 11.9722 29.2368 11.2754 29.5256C10.5785 29.8145 9.83145 29.9622 9.07728 29.9602H7.9292L15.3602 37.4004C16.4747 38.5139 17.9848 39.1393 19.5593 39.1393C21.1337 39.1393 22.6439 38.5139 23.7584 37.4004L31.2042 29.9441L30.4859 29.9391Z" fill="#131C46"/>
                                                    <path d="M9.07852 9.17596C9.8327 9.17395 10.5798 9.32162 11.2766 9.61045C11.9735 9.89928 12.6062 10.3235 13.1383 10.8587L19.0224 16.7513C19.2269 16.9555 19.5039 17.0701 19.7927 17.0701C20.0815 17.0701 20.3585 16.9555 20.5631 16.7513L26.4261 10.881C26.9578 10.3452 27.5904 9.92041 28.2873 9.63134C28.9842 9.34226 29.7315 9.19464 30.4859 9.19705H31.1918L23.746 1.74195C23.1946 1.1897 22.54 0.751616 21.8195 0.452727C21.099 0.153838 20.3268 0 19.5469 0C18.767 0 17.9948 0.153838 17.2743 0.452727C16.5538 0.751616 15.8991 1.1897 15.3478 1.74195L7.9292 9.17596H9.07852Z" fill="#131C46"/>
                                                    <path d="M37.3509 15.365L32.8514 10.8599C32.7499 10.9015 32.6415 10.9233 32.5319 10.9244H30.4859C29.4212 10.9271 28.4006 11.3504 27.646 12.1024L21.783 17.9691C21.255 18.4968 20.5394 18.7932 19.7933 18.7932C19.0473 18.7932 18.3317 18.4968 17.8037 17.9691L11.9184 12.0801C11.164 11.3277 10.1434 10.9038 9.07851 10.9008H6.56684C6.46333 10.8985 6.36104 10.8779 6.26465 10.8401L1.73671 15.365C0.624587 16.4809 0 17.9929 0 19.5693C0 21.1457 0.624587 22.6578 1.73671 23.7737L6.25474 28.2973C6.35092 28.2587 6.45334 28.2382 6.55693 28.2365H9.07851C10.1433 28.2334 11.1639 27.8096 11.9184 27.0573L17.8025 21.1659C18.8663 20.1019 20.7204 20.1019 21.783 21.1659L27.646 27.035C28.4006 27.787 29.4212 28.2103 30.4859 28.213H32.5319C32.6415 28.2138 32.75 28.2356 32.8514 28.2775L37.3509 23.7724C37.9024 23.2204 38.34 22.5649 38.6385 21.8435C38.937 21.1221 39.0906 20.3489 39.0906 19.5681C39.0906 18.7872 38.937 18.014 38.6385 17.2926C38.34 16.5712 37.9024 15.9158 37.3509 15.3637" fill="#131C46"/>
                                                </svg>
                                                Pagamento via PIX
                                            </h2>
                                            <p>Escaneie o QR Code ou copie o código para pagar</p>
                                        </div>
                                        <div className="pix-qr-image">
                                            {pixQrCodeUrl ? (
                                                <img src={pixQrCodeUrl} alt="QR Code PIX" />
                                            ) : (
                                                <div className="pix-qr-text">{pixQrCode}</div>
                                            )}
                                        </div>
                                        <div className="pix-copiar">
                                            <input type="text" readOnly value={pixQrCode} />
                                            <button onClick={() => {
                                                navigator.clipboard.writeText(pixQrCode);
                                                setTexto('Código PIX copiado!');
                                                mostrarModal();
                                            }}>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                                                    <path d="M3 11V3H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                                Copiar
                                            </button>
                                        </div>
                                        <p className="pix-aviso">Após o pagamento, seu pedido será confirmado automaticamente.</p>
                                        <button
                                            className="bnt-avancarCheckout"
                                            onClick={() => navigate(`/menu/perfil/meuspedidos`)}
                                        >
                                            Ver meus pedidos
                                        </button>
                                    </div>
                                )}

                                {!aguardandoPix && (
                                processando ? (
                                    <div className="checkout-processando" aria-live="polite">
                                        <div className="processando-icone" aria-hidden="true">
                                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18 7.5V18L25.5 22.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M30 18C30 24.6274 24.6274 30 18 30C11.3726 30 6 24.6274 6 18C6 11.3726 11.3726 6 18 6C24.6274 6 30 11.3726 30 18Z" stroke="currentColor" strokeWidth="2.5" />
                                            </svg>
                                        </div>
                                        <div className="processando-texto">
                                            <strong>Estamos finalizando seu pedido</strong>
                                            <p>Validando pagamento, estoque e dados de entrega.</p>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="bnt-opcoesPedido">
                                        {etapa > 1 && (
                                            <button className="bnt-voltarCheckout" onClick={etapaAnterior}>
                                                Voltar
                                            </button>
                                        )}
                                        {etapa < 3 ? (
                                            <button className="bnt-avancarCheckout" onClick={proximaEtapa}>
                                                Continuar
                                            </button>
                                        ) : (
                                            <button className="bnt-finalizarCheckout" onClick={finalizarPedido} disabled={processando}>
                                                Finalizar Pedido
                                            </button>
                                        )}
                                    </div>
                                )
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Rodape />
        </section>
    );
}
